import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';

import {ROLE_USER} from '../constants/userConstants';
import {SimpleUser} from '../qql-shared/fragments';
import Users from '../components/Users';
import {CreateCollectionFoldersMutation, CreateCollectionFoldersMutationConfig} from '../qql-shared/mutations';

export const UsersQuery = gql`
  query searchUsers($input: SearchUsersInput!) {
    searchUsers(input: $input) {
      ...SimpleUser
      lastUnpublishedChangeTimestamp
    }
  }
  ${SimpleUser}
`;

const SearchUsersConfig = {
  options: ({match}) => {
    return {
      variables: {input: {role: match.params.role ? match.params.role : ROLE_USER}},
      fetchPolicy: 'network-only',
    };
  },
};
export default compose(
  graphql(UsersQuery, SearchUsersConfig),
  graphql(CreateCollectionFoldersMutation, CreateCollectionFoldersMutationConfig)
)(Users);



// WEBPACK FOOTER //
// ./src/containers/UsersPage.js